<template>
  <v-stepper-content step="2" class="pb-0">
    <v-alert
      class="animated bounceIn"
      v-if="timeLeft == 0 && $store.getters['game/timer']"
      type="error"
    >{{$t('general.timerMessage')}}</v-alert>
    <v-sheet
      class="text-center mb-1 card-title"
      color="primary"
      elevation="1"
      dark
    >{{$t('steps.clientShipment')}}</v-sheet>
    <v-card class="pa-4" outlined :class="{'test-mode' : $store.getters['game/test']}">
      <v-row align="center">
        <v-col cols="3" align="center" class="animated bounceInLeft delay-1s">
          <v-row>
            <v-col cols="12" align="center">
              <img v-if="img === 1 && avatar === 0" style="width:80%;" src="@/assets/user/boy content.png" />
              <img v-if="img === 1 && avatar === 1" style="width:80%;" src="@/assets/user/girl content.png" />
              <img v-if="img === 2 && avatar === 0" style="width:80%;" src="@/assets/user/boy panique.png" />
              <img v-if="img === 2 && avatar === 1" style="width:80%;" src="@/assets/user/girl panique.png" />
              <img v-if="img === 3 && avatar === 0" style="width:80%;" src="@/assets/user/boy question.png" />
              <img v-if="img === 3 && avatar === 1" style="width:80%;" src="@/assets/user/girl question.png" />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3" align="center" class="animated bounceInLeft delay-1s">
          <v-row>
            <stock v-if="step === 2" :init-stock="$store.getters['company/stock']" :stock="dynamicStockLevel"></stock>
          </v-row>
        </v-col>
        <v-col cols="1" align="center" class="animated bounceIn">
          <v-row>
            <v-col cols="12" align="center">
              <v-divider class="custom-divider"></v-divider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="5" align="center" class="animated bounceInRight delay-1s">
          <v-row v-for="client in localClients" :key="client.data._id" align="center">
            <v-col cols="4" align="center">
              <company-logo
                :name="client.data.client.name"
                :logo="filesUrl + 'logo/' + client.data.client.companieSettings.logo"
              ></company-logo>
            </v-col>
            <v-col cols="8">
              <v-menu
                v-model="client.edit"
                :close-on-content-click="false"
                :close-on-click="false"
                right
                :nudge-width="0"
              >
                <template v-slot:activator="{ }">
                  <v-text-field
                    readonly
                    min="0"
                    type="number"
                    v-model.number="client.shipment"
                    outlined
                    :hint="$t('clientsShimpents.remains') + client.actualRemains"
                    persistent-hint
                    append-outer-icon="mdi-pencil"
                    @click:append-outer.stop="openEditValue(client)"
                  ></v-text-field>
                </template>

                <v-card>
                  <v-form @submit.prevent="checkValue(client)">
                    <v-card-text>
                      <v-text-field
                        :ref="'editval' + client.data.client._id"
                        min="0"
                        type="number"
                        v-model.number="client.newVal"
                        
                        :hint="$t('clientsShimpents.remains') + client.actualRemains"
                        persistent-hint
                      >
                      <template v-slot:append-outer>
                        <v-btn class="mx-1" fab color="success" type="submit"><v-icon>mdi-check</v-icon></v-btn>
                        <v-btn outlined class="mx-1" fab color="error" @click="client.edit = false"><v-icon>mdi-close</v-icon></v-btn>
                    
                      </template>
                      </v-text-field>
                    </v-card-text>
                  </v-form>
                </v-card>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
    <v-row>
      <v-col cols="12" align="center">
        <v-btn
          :disabled="readyForValidation < 2"
          class=""
          :class="{'animated heartBeat infinite slow' : readyForValidation == 2, 'animated bounceIn delay-2s': readyForValidation < 2}"
          color="primary"
          :loading="$store.state.company.loading"
          @click="validate"
        >{{validationMessage}}</v-btn>
      </v-col>
    </v-row>
    <v-dialog v-model="shipmentDialog" persistent width="600px">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" align="center">
              <v-img width="300px" src="@/assets/icon/livraison client.png"></v-img>
            </v-col>
            <v-col cols="12" align="center">
              <p
                style="font-size: 26px; font-weight: 900"
              >{{$tc('clientsShimpents.shipmentsResume', resumeShipments , {nbr: resumeShipments})}}</p>
              <p
                v-if="resumeRemains > 0"
                style="font-size: 26px; font-weight: 900; color: #cc0000;"
              >{{$tc('clientsShimpents.remainResume', resumeRemains, {nbr: resumeRemains}) }}</p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :loading="$store.state.company.loading"
            :disabled="$store.state.company.loading"
            @click="$store.dispatch('company/setStep', 3)"
          >{{$t('general.ok')}}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-stepper-content>
</template>

<script>
import { mapGetters } from "vuex";
import CompanyLogo from "@/components/CompanyLogo";
import Stock from "@/components/Stock2";

export default {
  name: "ClientsShipments",
  components: {
    CompanyLogo,
    Stock
  },
  props: {
    step: Number,
    timeLeft: Number
  },
  data: () => ({
    localClients: [],
    stock: 0,
    dynamicStockLevel: 0
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.localClients = [];
      this.stock = this.$store.getters["company/stock"];
      for (let client of this.$store.state.company.data.data.clients) {
        let remains = client.requests[client.requests.length - 1];
        remains += client.remains[client.remains.length - 1]
          ? client.remains[client.remains.length - 1]
          : 0;
        this.localClients.push({
          data: Object.assign({}, client),
          shipment: 0,
          initialRemains: remains,
          actualRemains: remains,
          edit: false,
          newVal: 0
        });
      }
      this.dynamicStockLevelCount();
    },
    async openEditValue (client) {
      client.newVal = client.shipment
      client.edit = true;
      await this.$nextTick()
      setTimeout(() => this.$refs['editval' + client.data.client._id][0].focus(),100)
      
      
    },
    checkValue(client) {
      client.shipment = client.newVal
      this.localClients.forEach(client => {
        if (client.shipment < 0 || client.shipment == "") {
          client.shipment = 0;
        }
      });
      if (this.totalShipment > this.stock) {
        client.shipment =
          this.stock -
          this.otherShipmentsSum(client.data.client._id.toString());
      }

      if (client.shipment > client.initialRemains) {
        client.shipment = client.initialRemains;
      }
      client.actualRemains = client.initialRemains - client.shipment;
      this.dynamicStockLevelCount();
      client.edit = false
    },
    dynamicStockLevelCount() {
      this.dynamicStockLevel =
        this.$store.getters["company/stock"] - this.totalShipment;
    },
    otherShipmentsSum(excludeClient) {
      return this.localClients.reduce((prev, curr) => {
        if (curr.data.client._id.toString() != excludeClient) {
          return prev + curr.shipment;
        } else {
          return prev;
        }
      }, 0);
    },
    async validate() {
      let params = {
        shipments: this.localClients.map(client => {
          return {
            client: client.data.client._id,
            shipments: client.shipment,
            remains: client.actualRemains
          };
        }),
        stock: this.dynamicStockLevel
      };
      await this.$store.dispatch("company/clientsShipments", params);
    }
  },
  computed: {
    readyForValidation() {
      let answer = 2;
      let remainsSum = 0
      this.localClients.forEach(client => {
        if (client.shipment === "") {
          answer = 0;
        }
        remainsSum += client.actualRemains
      });
      if (remainsSum > 0 && this.dynamicStockLevel > 0 && answer == 2) {
        answer = 1
      }
      return answer;
    },
    shipmentDialog() {
      return this.$store.state.company.data
        ? this.$store.state.company.data.clientShipmentResume
        : false;
    },
    totalShipment() {
      return this.localClients.reduce((prev, curr) => prev + parseInt(curr.shipment), 0);
    },
    totalRemains() {
      return this.localClients.reduce(
        (prev, curr) => prev + curr.initialRemains,
        0
      );
    },
    totalActualRemains() {
      return this.localClients.reduce(
        (prev, curr) => prev + curr.actualRemains,
        0
      );
    },
    img() {
      if (this.totalActualRemains === 0) {
        return 1;
      } else if (this.dynamicStockLevel === 0) {
        return 2;
      } else {
        return 3;
      }
    },
    resumeShipments() {
      if (this.$store.state.company.data) {
        let sum = 0;
        this.$store.state.company.data.data.clients.forEach(client => {
          if (client.deliveries.length > 0) {
            sum += client.deliveries[client.deliveries.length - 1];
          }
        });
        return sum;
      } else {
        return 0;
      }
    },
    resumeRemains() {
      if (this.$store.state.company.data) {
        let sum = 0;
        this.$store.state.company.data.data.clients.forEach(client => {
          if (client.remains.length > 0) {
            sum += client.remains[client.remains.length - 1];
          }
        });
        return sum;
      } else {
        return 0;
      }
    },
    validationMessage() {
      let message = ""
      switch (this.readyForValidation) {
        case 0:
          message = this.$t('clientsShimpents.chooseQuantity')
          break;
        case 1:
          message = this.$t('clientsShimpents.notMax')
          break;
        case 2:
          message = this.$t('clientsShimpents.ok')
          break;
      }
      return message
    },
    
    ...mapGetters("company", {
      filesUrl: "filesUrl",
      avatar: "avatar"
    })
  },
  watch: {
    step(val) {
      if (val === 2) {
        this.init();
      }
    }
  }
};
</script>
<style >
.v-messages__message {
  font-size: 18px;
  font-weight: 900;
  line-height: 18px !important;
}
</style>